import PostalStamp from '../PostalStamp';

/**
 * Calabaza de Halloween dentro del marco de PostalStamp — el matasellos de
 * octubre. Mismo vocabulario que FireworksIcon y SummerSunIcon (trazo
 * lineal, un solo marco postal), para que las temporadas se lean como una
 * colección y no como ilustraciones sueltas.
 *
 * La luz de la cara usa --stock-oro, un color que ya existe en el catálogo:
 * el brillo de la calabaza es el mismo amarillo del papel oro.
 */
export default function PumpkinIcon({ className = '' }) {
    return (
        <PostalStamp topText="TEMPORADA · OCTUBRE" bottomText="HALLOWEEN" className={className} color="var(--calabaza)">
            {/* Tallo */}
            <path d="M60 36 C60 31 62 28 66 27" stroke="var(--stock-verde)" strokeWidth="3" strokeLinecap="round" />
            {/* Cuerpo: tres gajos superpuestos */}
            <ellipse cx="45" cy="62" rx="14" ry="19" fill="var(--calabaza)" fillOpacity="0.22" stroke="var(--calabaza)" strokeWidth="1.8" />
            <ellipse cx="75" cy="62" rx="14" ry="19" fill="var(--calabaza)" fillOpacity="0.22" stroke="var(--calabaza)" strokeWidth="1.8" />
            <ellipse cx="60" cy="62" rx="15" ry="21" fill="var(--calabaza)" fillOpacity="0.32" stroke="var(--calabaza)" strokeWidth="1.8" />
            {/* Ojos y boca encendidos */}
            <path d="M49 56 L56 56 L52.5 50 Z" fill="var(--stock-oro)" />
            <path d="M64 56 L71 56 L67.5 50 Z" fill="var(--stock-oro)" />
            <path
                d="M48 67 L53 72 L57 67 L60 73 L63 67 L67 72 L72 67 L70 77 L50 77 Z"
                fill="var(--stock-oro)"
            />
        </PostalStamp>
    );
}
